// extracted by mini-css-extract-plugin
export default {"fieldBox":"TelUtil_fieldBox__0E2hk","field":"TelUtil_field__rGWb7","errorMessage":"TelUtil_errorMessage__DWBmc"};